@if (planList$ | async; as planList) {
    @if (planList.length > 0) {
        <div class="rows">
            <checkout-mobile-block-multiple
                [cartForm]="mixedForm"
                [quoteIndex]="quoteIndex"
                (selectPlanEvent)="changeOffer($event)"
                [offers]="planList"
                [isMobile]="isMobile"
            />

            @if (currentPlan && sims?.length > 1) {
                <div checkoutCy="sim_block" class="row">
                    <checkout-sim
                        (simChoice)="onSimChoice($event)"
                        [hasPhone]="false"
                        [simContext]="simContext"
                        [selectedSim]="currentSimChoice"
                        [isRenew]="false"
                        [isLoading]="isLoading"
                        [currentPlan]="currentPlan"
                    />
                </div>
            }
            @if (currentPlan?.hasPorta) {
                <div checkoutCy="porta_block" class="row">
                    <checkout-portability
                        [cartForm]="mixedForm"
                        [isSubmitted]="isSubmitted"
                        [plan]="currentPlan"
                        [quoteIndex]="quoteIndex"
                    />
                </div>
            }
            @if (currentPlan) {
                <div checkoutCy="parental_control_block" class="row">
                    <checkout-parental-control
                        [cartForm]="mixedForm"
                        [plan]="currentPlan"
                        [quoteIndex]="quoteIndex"
                        [isMobile]="isMobile"
                    />
                </div>
            }
        </div>
    }
}
